import { ORGANIZATIONS_API, ORGANIZATIONS_STAT_API, SUBCATEGORY_STAT_API } from "../../../Utilities/APIs";
import PcASSCRUD from "../../Partials/Layouts/CRUDs/CRUDLayouts/ASSCRUD/PcASSCRUD";

function OrganizationStatCards() {
  return (
    <PcASSCRUD
      // parentChild props
      parentDBField={'organization'}
        
      // common props
      api={ORGANIZATIONS_STAT_API}
      screenTopicSingular={'Organization Stat Card'}
      screenTopicPlural={'Organization Stat Cards'}
      
      // crud header props
      showTotalInHeading
      
      // crud props
      allowCreate
      allowUpdate
      allowDelete
      
      // select props
      selectApi={ORGANIZATIONS_API}
      selectType={'parent-child'}
      selectDBField={'organization'}
      selectName={'Organization'}

      // second select props
      secondSelectApi={SUBCATEGORY_STAT_API}
      secondSelectType={'parent-child'}
      secondSelectDBField={'subcatStatCard'}
      secondSelectName={'Subcategory Stat Card'}
    />
  )
}

export default OrganizationStatCards